export default class MapPin {
  constructor(store, isInPostStoreLocatorRebrandEnabled = false) {
    this.store = store;
    this.isInPostStoreLocatorRebrandEnabled = isInPostStoreLocatorRebrandEnabled;
  }

  icon() {
    const iconMap = {
      PaypointStore: {
        selected: "/assets/store-locator/store-selected-pin.svg",
        closed: "/assets/store-locator/store-closed-pin.svg",
        default: "/assets/store-locator/store-default-pin.svg",
      },
      InPostLocker: {
        selected: "/assets/store-locator/locker-selected-pin.svg",
        closed: "/assets/store-locator/locker-closed-pin.svg",
        default: "/assets/store-locator/locker-default-pin.svg",
      },
    };

    if (this.isInPostStoreLocatorRebrandEnabled) {
      iconMap.PaypointStore = {
        selected: "/assets/store-locator/inpost-store-selected-pin.svg",
        closed: "/assets/store-locator/inpost-store-closed-pin.svg",
        default: "/assets/store-locator/inpost-store-default-pin.svg",
      };
    }
  
    const type = this.store.store_type;
    const status = this.store.selected ? "selected" : this.store.closed ? "closed" : "default";
  
    return iconMap[type]?.[status] || iconMap.PaypointStore.default;
  }
  

  numberClass() {
    if (this.store.selected) {
      return "number number--selected";
    } else if (this.store.closed) {
      return "number number--closed";
    }
    return "number number--default";
  }
}
